<template>
  <div id="app">
    <global-header></global-header>
    <router-view :key="$route.fullPath"></router-view>
    <global-footer></global-footer>
  </div>
</template>

<script>
import axios from 'axios'
import GlobalHeader from '@/components/common/GlobalHeader'
import GlobalFooter from '@/components/common/GlobalFooter'

export default {
  name: 'app',
  components: { GlobalHeader, GlobalFooter },
  created() {
    this.setAxios()

    if (!this.isGuestPage) {
      this.$store.dispatch('user/getMe')
        .then(() => {
          // nothing to do
        })
        .catch(e => {
          this.$router.push({ name: 'login' })
        })
    }
  },
  computed: {
    isGuestPage() {
      const arr = [ 'login' ]
      return arr.indexOf(this.$route.name) !== -1
    }
  },
  methods: {
    setAxios() {
      axios.defaults.baseURL = '/api/v1'

      // x-api-key
      const apiKey = this.$store.getters['localStorage/apiKey']
      if (apiKey) {
        axios.defaults.headers['X-API-KEY'] = apiKey
      }

      // go to login if 401 is returned
      axios.interceptors.response.use(
        response => {
          return response
        },
        error => {
          const st = error.response.status
          if (st === 401 && !this.isGuestPage) {
            setTimeout(() => {
              location.href = '/login'
            }, 0)
          }
          return Promise.reject(error)
        }
      )
    },
  },
}
</script>

<style lang="scss">
  @import '@/style/global_vars.scss';
  @import '@/style/app.scss';
</style>
